export default __webpack_public_path__ + "static/media/logo-numbr.4819aad8.svg";